/**
 * What kind of pointer is driving the app.
 *
 * The one thing this is for: a field that focuses itself. On a desktop that is a courtesy — the
 * draft page opens, the caret is already in the search box, you type three letters of a name and
 * hit enter. On a phone it is the opposite. Focus opens the keyboard, the keyboard eats half the
 * screen, and iOS scrolls the page to keep the field visible — so merely arriving at the Draft
 * page (or flipping the mock switch, which re-renders it) throws you into a half-covered view of
 * a board you were trying to look at.
 *
 * `pointer: coarse` and not a width query, deliberately: an iPad in landscape is 1024px wide and
 * has exactly the same keyboard problem as a phone.
 */
export function isCoarsePointer(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(pointer: coarse)').matches;
}
